export const inputStyle = {
  backgroundColor: "#ffffff",
  border: "1.5px solid #b783cc",
  borderRadius: "5px",
  paddingTop: "0px",
  fontFamily: "'Archivo',sans-serif",
};

export const inputLabel = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: {
    sm: "18px",
    md: "20px",
    lg: "22px",
  },
};

export const outputLabel = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "13px",
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  fontWeight: 700,
};

export const outputStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "24px",
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  fontWeight: 700,
  color: "#005FB9",
};
